
    const data = {"name":"src/core/icons/stop","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M18 18H6V6h12v12Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            